import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import ContentContainer from "../../components/ContentContainer";
import FooterContent from "../../components/FooterContent";
import "./Payment.scss";
import { useParams } from "react-router-dom";
import apiOrder from "../../apis/api.order";
import apiUser from "../../apis/api.user";
import PaymentTicket from "../../components/PaymentTicket";
import { toast, ToastContainer } from "react-toastify";

function Payment() {
  const { orderId } = useParams();
  const [total, setTotal] = useState(0);
  const [tickets, setTickets] = useState([]);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  useEffect(() => {
    const getData = async () => {
      const res = await apiOrder.getTicketsByOrderId(orderId);
      if (res) {
        setTickets(res.elements);
        let _total = 0;
        for (let i = 0; i < res.elements.length; i++) {
          _total += res.elements[i].ticket_count * res.elements[i].ticket_price;
        }
        setTotal(_total);
      }
    };
    getData();
  }, []);

  const handleClickPayment = async () => {
    window.location.href = `/payment/test/${orderId}`;
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <>
        <div className="payment-background">
          <div className="center">
            <h2>Thông tin thanh toán</h2>
          </div>
          <div className="payment-info-container">
            <div className="payment-info-col-1">
              <h2>Danh sách vé</h2>
              <>
                {tickets.map((item) => (
                  <>
                    <PaymentTicket ticket={item} />
                  </>
                ))}
              </>
            </div>
            <div className="payment-info-col-2">
              <h3>Phương thức thanh toán</h3>
              <p>Thanh toán qua Payoo</p>
              <p>Ban dang thanh toan cho don hang {orderId}</p>
              <p>Tổng cộng {numberWithCommas(total)} VND</p>
              <button onClick={() => handleClickPayment()}>Thanh Toán</button>
            </div>
          </div>
        </div>{" "}
      </>
      <FooterContent />
    </>
  );
}
export default Payment;
